export default {"src":"/_next/static/media/Group_2.1ec1347d.svg","height":163,"width":130,"blurWidth":0,"blurHeight":0};